import React from 'react';

const Game = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.6652 12.5L15.0569 16.07C15.3425 16.3705 15.7179 16.5704 16.1268 16.6395C16.5356 16.7086 16.9558 16.6433 17.3243 16.4533C17.6929 16.2634 17.9899 15.959 18.1708 15.5859C18.3517 15.2129 18.4068 14.7912 18.3277 14.3842L16.9944 7.52416M6.66524 7.49999V9.16666M5.83191 8.33332H7.49858M11.6652 8.33332H13.3319M12.9152 4.16666C14.0203 4.16666 15.0801 4.60564 15.8615 5.38704C16.6429 6.16845 17.0819 7.22825 17.0819 8.33332C17.0819 9.43839 16.6429 10.4982 15.8615 11.2796C15.0801 12.061 14.0203 12.5 12.9152 12.5H8.33191L4.98607 16.0225C4.69987 16.3238 4.32349 16.524 3.91364 16.5928C3.5038 16.6615 3.08269 16.5953 2.71379 16.4039C2.34489 16.2125 2.04818 15.9065 1.86837 15.5318C1.68857 15.1571 1.63541 14.7342 1.71691 14.3267L3.07857 7.51582C3.26758 6.57121 3.77806 5.72127 4.52315 5.11064C5.26824 4.50001 6.2019 4.16643 7.16524 4.16666H12.9152Z",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
Game.displayName = "Icons.Game";

export { Game };
//# sourceMappingURL=Game.js.map
